module.exports = __webpack_public_path__ + "img/Group8662_2x.aa1d38a0.png";